<template>
  <div class="wapper">
    <div class="query-wapper">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="合约公司名称" v-model="query.name"></el-input>
        </el-col>
        <el-col :span="6">
          <el-select placeholder="合约公司状态" v-model="query.state" style="width:100%;">
            <el-option v-for="item in states" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="button-wapper">
        <el-button plain @click="getInfoList(undefined)">查询</el-button>
        <el-button plain @click="reset">重置</el-button>
        <el-button plain @click="add" type="primary" v-auth="'edit'">新增</el-button>
        <el-button plain @click="changeChannel" type="primary" v-auth="'edit'" v-if="superRole == 3">切换渠道</el-button>
        <span v-if="superRole == 3" class="channelinfo">提示：当前查看的模板为：{{ChannelName}}模板</span>
      </div>
    </div>
    <div class="content-wapper">
      <el-table :data="infos" size='mini' empty-text :border="true">
        <el-table-column prop="id" label="合约公司标识"></el-table-column>
        <el-table-column prop="name" label="合约公司名称" width="200"></el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间"></el-table-column>
        <el-table-column prop="creatorName" label="创建人名称"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-auth="'edit'" v-model="scope.row.state" @change="updateContractCompanyState(scope.row)"
              :active-value="1" :inactive-value="2" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
            <span v-auth-reverse="'edit'">
              {{ scope.row.stateValue }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="170">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="text" size="small" v-auth="'edit'">编辑</el-button>
            <el-button @click="getDetail(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination :current-page.sync="query.pageIndex" :page-size="query.pageSize"
        @current-change="handleCurrentChange" class="pagation" layout="prev, pager, next, jumper" :total="query.total">
      </el-pagination>
    </div>
    <!-- 添加合约公司 -->
    <addInvoiceCompany ref="addInvoiceCompany" @refresh="getInfoList" :channelCode="channel" :channelName="ChannelName"></addInvoiceCompany>
    <el-dialog title="切换渠道" :visible.sync="dialogVisible" width="650px">
      <el-form>
          <el-form-item label="切换渠道" label-width="80px">
            <el-select v-model="channel" placeholder="请选择渠道">
              <el-option v-for="item in channelList" :key="item.channelCode" :label="item.channelName" :value="item.channelCode"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmChange">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import _invoiceCompany from '@/service/invoice-company-service'
import _constant from '@/utils/constant'
import _channel from '@/service/channel-service'
import _userinfo from '@/service/userinfo-service'
import addInvoiceCompany from '@/views/invoice/company/add-invoice-company'
export default {
  components: {
    addInvoiceCompany
  },
  data() {
    return {
      dialogVisible:false,
      ChannelName:null,
      channel:null,
      superRole:0,
      channelList:[],
      infos: null,
      states: null,
      bodyTypes: null,
      query: {
        name: null,
        state: null,
        bodyType: null,
        pageIndex: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted() {
    // 查询登录用户
    _userinfo.getLoginUser(response => {
      this.channel = response.channelCode
      this.getInfoList()
    })
    // 状态
    this.states = _constant.states
    // 主体类型
    _channel.getTabPage(res => {
      this.ChannelName = res.list[0].channelName
      this.superRole = res.superRole
      this.channelList = res.list
      this.channel = res.list[0].channelCode
    })
  },
  methods: {
    confirmChange() {
      if(!this.channel) {
        this.$notify({
          message: '请选择渠道',
          type: 'warning'
        });
        return
      }
      this.channelList.forEach((item) => {
        if(item.channelCode == this.channel) {
          this.ChannelName = item.channelName
        }
      })
      this.getInfoList();
      this.dialogVisible = false
    },
    changeChannel() {
      this.dialogVisible = true
    },
    getInfoList(pageIndex) {
      if (pageIndex)
        this.query.pageIndex = pageIndex
      else
        this.query.pageIndex = 1
      this.query.channelCode = this.channel || 'QD0000'
      _invoiceCompany.getContractCompanyList(
        this.query,
        (response, total) => {
          // 请求成功
          this.infos = response
          this.query.total = total
        })
    },
    handleCurrentChange(pageIndex) {
      this.getInfoList(pageIndex)
    },
    add() {
      this.$refs.addInvoiceCompany.show()
    },
    getDetail(row) {
      this.$saveParams(this.query)
      this.$router.push({
        path: '/invoice-company-detail?id=' + row.id
      })
    },
    edit(row) {
      this.$saveParams(this.query)
      this.$refs.addInvoiceCompany.show(row.id)
    },
    reset() {
      this.query = {
        name: null,
        state: null,
        pageIndex: 1,
        pageSize: 20,
        total: 0
      }
      this.getInfoList()
    },
    updateContractCompanyState(rows) {

      this.$confirm(`是否确认要${rows.state == 1 ? '开启' : '关闭'}该合约公司状态，${rows.state == 1 ? '开启后' : '关闭后'}销售下单时将${rows.state == 1 ? '可继续使用该公司' : '不可继续使用该公司'}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        _invoiceCompany.updateContractCompanyState(rows.id, rows.state, () => {
          this.$notify({
            message: '修改成功',
            type: 'success'
          });
        })

      }).catch(() => {
        rows.state == 2 ? rows.state = 1 : rows.state = 2
        this.$message({
          message: '已取消'
        });

      })





    }
  }
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}

.header {
  margin-bottom: 15px;
}

.query-wapper {
  margin: 15px;
  padding: 15px;
  border: 1px solid #d6dbe5;
  position: relative;
  background: #fff;
}

.query-wapper::after {
  position: absolute;
  content: "筛选条件";
  top: -9px;
  color: #909399;
  background-color: #fbfbfb;
}

.content-wapper {
  padding: 0 15px;
  padding-bottom: 30px;
}

.button-wapper {
  margin-top: 10px;
}

.el-row {
  margin-bottom: 15px;
}
.channelinfo{
  margin-left: 10px;
  color: red;
  font-weight: bold;
}
</style>